import styled from 'styled-components'
import { Box, Link } from 'pcln-design-system'
import get from 'lodash/get'

export const UpdateLink = styled(Link)`
  display: inline-block;
  text-decoration: underline;
  margin-top: 8px; //using DS directly prop doesn't work
`

export const BannerContainer = styled(Box)`
  ${props => get(props, 'theme.flyQueries.mobile', '')} {
    padding: 0 8px 0 8px;
  }}
`
